import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { of } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Constants, HTTPStatusCode } from '../core/Constants';
import { API_CMS_ENDPOINT, API_ENDPOINT } from '../core/DI';
import { LastSubject } from '../core/LastSubject';
import { AccessoryCategoryFilter } from '../core/models/accessory-category-filter.model';
import { CategoryFiltersRequestDto, StringCategoryFilter } from '../core/models/filter-backend';
import { GenericCardAndFiltersDtoResponse } from '../core/models/generic-card-and-filter.dto-response';
import { KitComponentsDtoResponse } from '../core/models/kit-components.dto-response';

import { GenericDetailDtoResponse } from '../core/models/generic-detail.dto-response';
import { MakeYearModel } from '../core/models/make-year-model.model';
import { PackageBuilderPackage } from '../core/models/package-builder-package';
import { ProductCategoryFilter } from '../core/models/product-category-filter.model';
import { ProductDetailsDtoResponse } from '../core/models/product-details.dto-response';
import { ProductSpecsOptions } from '../core/models/product-specs-options.model';
import { Product } from '../core/models/product.model';
import { StaggeredPackageBuilderModel } from '../core/models/staggered-package-builder.model';
import { StaggeredProductDetailsDtoResponse } from '../core/models/staggered-product-details.dto-response';
import { StringValueId } from '../core/models/stringvalue-id.model';
import { IProductService } from '../shared/iproduct.service';
import { PagingService } from '../shared/paging.service';
import { Helper } from './helper';
import { GenericSummaryCardDtoResponse } from 'app/core/models/generic-summary-card.dto-response';
import { KitPackage } from 'app/core/models/kit-package';
import { PackageBuilderModel } from 'app/core/models/package-builder.model';
import { CustomerFeedbackOption } from "app/core/models/customer-feedback-option";

@Injectable()
export class HardwareService implements IProductService {
  private hardwaresSubjectPackageBuilder = new LastSubject<GenericDetailDtoResponse[]>();
  private hardwaresSubject = new LastSubject<GenericCardAndFiltersDtoResponse>();
  private searchWithFilterInProgress = new Subject<boolean>();
  private componentsSubject = new LastSubject<KitComponentsDtoResponse>();

    private searchMym = new MakeYearModel();

    // djb:debug-used to locate multiple instances
    public id: string;
    customParameter: {} = null;
    region: string;

  constructor(
    @Inject(API_ENDPOINT) private apiEndpoint: string,
    @Inject(API_CMS_ENDPOINT) private apiCmsEndpoint: string,
    private http: HttpClient,
    private pagingService: PagingService) {
    this.id = Helper.generateId(1);
    this.log('constructor');

    if (sessionStorage.getItem("vehicleCountry") == null) {
      sessionStorage.setItem("vehicleCountry", "Canada");
      this.region = "Canada";
    }
    else {
      this.region = sessionStorage.getItem("vehicleCountry")
    }
  }

  get onProducts(): Observable<GenericCardAndFiltersDtoResponse> {
    return this.hardwaresSubject.asObservable();
  }

  get onSearchWithFilter(): Observable<boolean> {
    return this.searchWithFilterInProgress.asObservable();
  }

  // Used by package builder step hardware.
  get onHardwares(): Observable<GenericDetailDtoResponse[]> {
    return this.hardwaresSubjectPackageBuilder.asObservable();
  }

    get onComponents(): Observable<KitComponentsDtoResponse> {
        return this.componentsSubject.asObservable();
    }

  getProductFilters(): Observable<ProductSpecsOptions[]> {
    // djb:ngup8
    //return Observable.of([]);
    return of([]);
  }

    getProductByBrandFilters(): Observable<ProductSpecsOptions[]> {
        throw new Error('NotSupportedException');
    }

  searchWithTextAndFilter(searchText: string, filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {
    throw new Error('NotSupportedException');
  }

    getProductDetailsByVehicleAndFilterAndStyleAndFinish(carDetails: MakeYearModel, wheelStagger: string, filters: CategoryFiltersRequestDto)
        : Observable<Array<GenericSummaryCardDtoResponse>> {
        throw new Error('NotSupportedException');
    }

  getProductDetailsBySpecs(productId: string, carDetails: MakeYearModel = null): Observable<ProductDetailsDtoResponse> {
    // djb:encode productId for items with special chars (AK3/16)
    //const api = `${this.apiEndpoint}/${this.region}/${this.apiEndpoint}/accessories/${productId}`;

    var currentRegion = sessionStorage.getItem("vehicleCountry");
    this.region = currentRegion != null ? currentRegion : "Canada";
    let api = `${this.apiEndpoint}/${this.region}/accessories/`;
    if (carDetails)
      api += `makes/${Helper.encodeURIComponent2(carDetails.make)}/` +
        `years/${Helper.encodeURIComponent2(carDetails.year)}/` +
        `models/${Helper.encodeURIComponent2(carDetails.model)}/` +
        `submodels/${Helper.encodeURIComponent2(carDetails.submodel)}/id/`;
    api += `${Helper.encodeURIComponent2(productId)}`;
    return this.http.get<ProductDetailsDtoResponse>(api);
  }

  getProductDetails(productId: string, carDetails: MakeYearModel,
    frontWheelOrTireId: string, rearWheelOrTireId: string = ''): Observable<ProductDetailsDtoResponse> {
    var currentRegion = sessionStorage.getItem("vehicleCountry");
    this.region = currentRegion != null ? currentRegion : "Canada";
    let api = `${this.apiEndpoint}/${this.region}/accessories/` +
      `makes/${Helper.encodeURIComponent2(carDetails.make)}/` +
      `years/${Helper.encodeURIComponent2(carDetails.getYearStr)}/` +
      `models/${Helper.encodeURIComponent2(carDetails.model)}/` +
      `submodels/${Helper.encodeURIComponent2(carDetails.submodel)}/` +
      `options/${Helper.encodeURIComponent2(carDetails.option)}/` +
      `summer/${Helper.encodeURIComponent2((carDetails.isSummerSeason ? 1 : 0).toString())}/`;
    if (frontWheelOrTireId !== '' && rearWheelOrTireId !== '') {
      api += `wheels/${frontWheelOrTireId}/${rearWheelOrTireId}/`;
    } else if (frontWheelOrTireId !== '') {
      api += `wheels/${frontWheelOrTireId}/`;
    }
    api += `id/${productId}/`;
    return this.http.get<ProductDetailsDtoResponse>(api);
  }

  getStaggeredProductDetails(productId: string, carDetails: MakeYearModel,
    frontWheelOrTireId: string, rearWheelOrTireId: string): Observable<StaggeredProductDetailsDtoResponse> {
    throw new Error('Method not implemented.');
  }

    getStaggeredProductDetailsBySpecs(productId: string, carDetails: MakeYearModel = null): Observable<StaggeredProductDetailsDtoResponse> {
        throw new Error('Method not implemented.');
    }

  postProductToCart(id: string, qty: number, warningNotes: string[], pairNo: string, productType: string, productStyle: string = null) {
    let api = `${this.apiCmsEndpoint}/cart/AddProduct`;
    const product: Product = new Product({
      id: id,
      quantity: qty,
      warningNotes: warningNotes,
      type: Constants.PRODUCT_TYPE_HARDWARE,
      pairNo: pairNo
    });

        if (this.customParameter !== null && this.customParameter['accessoriesGroup'])
            product['AccessoriesGroup'] = this.customParameter['accessoriesGroup'];

    // WIP - SEASONAL CARE PLAN
    if (this.customParameter !== null && this.customParameter['scpReplaceCartContent'] !== null) {
      const _scpReplaceCartContent = this.customParameter['scpReplaceCartContent'];
      if (_scpReplaceCartContent)
        api = `${this.apiCmsEndpoint}/cart/AddProduct?scpReplaceCartContent=true`;
    }

    this.http.post(api, product).toPromise().then(_response => {
      if (productStyle !== null) {
        let upsellQty = qty
        if (this.customParameter !== null && this.customParameter['upsellQty'])
          upsellQty = this.customParameter['upsellQty'];

                if (productStyle.includes("Center Caps") || productStyle.includes("Cap Screws")) {
                    const urlParams = productStyle.substring(productStyle.indexOf('|') + 1);
                    window.location.href = `/fastfinder/shop/search-by-specs/accessories/results?upsellQty=${upsellQty}${urlParams}&stdCap=${id}`;
                }
                else if (productStyle.includes("Emblems")) {
                    const urlParams = productStyle.substring(productStyle.indexOf('|') + 1);
                    window.location.href = `/fastfinder/shop/search-by-specs/accessories/results?categoryId=9&productId=${id}&upsellQty=${upsellQty}${urlParams}&stdEmblem=${id}`;
                }
                else if (productStyle.includes("Spline") || productStyle.includes("Tuner"))
                    window.location.href = "/fastfinder/shop/search-by-specs/accessories/results?categoryId=90&productId=" + id;
                else
                    window.location.href = "/fastfinder/shop/search-by-specs/accessories/results?categoryId=92&productId=" + id;
            }
            else
                window.location.href = Constants.SHOPPING_CART_HREF;
        }).catch((err: any) => {
            window.location.href = Constants.SHOPPING_CART_HREF;
        });
    }

    createProduct(id: string, qty: number, productType: string, warningNotes: string[], pairNo: string, sequence: number): Product {
        return new Product({
            id: id,
            warningNotes: warningNotes,
            quantity: qty,
            type: productType, //Constants.PRODUCT_TYPE_WHEEL,
            pairNo: pairNo,
            sequence: sequence
        });
    }

    postProductPairToCart(frontId: string, frontQty: number, frontWarningNotes: string[], rearId: string, rearQty: number, rearWarningNotes: string[], pairNo: string, productType: string) {
        throw new Error('Method not implemented.');
    }

  postProductsToCart(frontProduct: Product, rearProduct: Product, frontLabours: Product[], rearLabours: Product[], car: MakeYearModel) {
    let api = `${this.apiCmsEndpoint}/cart/AddPackage`;
    const packageBuilderPackage: PackageBuilderPackage = new PackageBuilderPackage();
    packageBuilderPackage.makeYearModel = car;
    packageBuilderPackage.package = new StaggeredPackageBuilderModel();
    packageBuilderPackage.package.front.hardwares = [frontProduct];
    if (rearProduct) {
      packageBuilderPackage.package.rear.hardwares = [rearProduct];
    }
    packageBuilderPackage.package.front.labours = rearLabours;

    // WIP - SEASONAL CARE PLAN
    if (this.customParameter !== null && this.customParameter['scpReplaceCartContent'] !== null) {
      const _scpReplaceCartContent = this.customParameter['scpReplaceCartContent'];
      if (_scpReplaceCartContent)
        api = `${this.apiCmsEndpoint}/cart/AddPackage?scpReplaceCartContent=true`;
    }

    this.http.post(api, packageBuilderPackage).toPromise().then(response => {
      window.location.href = Constants.SHOPPING_CART_HREF;
    }).catch((err: any) => {
      //window.location.href = Constants.SHOPPING_CART_HREF;
      //display custom error to user.
    });
  }

  postToCartWithCar(frontId: string, frontQty: number,
    rearId: string = null, rearQty: number = null, frontWarningNotes: string[], rearWarningNotes: string[], car: MakeYearModel, pairNo: string) {
    const rearProduct = rearId && rearQty ? new Product({
      id: rearId,
      warningNotes: rearWarningNotes,
      quantity: rearQty,
      type: Constants.PRODUCT_TYPE_HARDWARE,
      pairNo: pairNo
    }) : null;

    this.postProductsToCart(
      new Product({
        id: frontId,
        warningNotes: frontWarningNotes,
        quantity: frontQty,
        type: Constants.PRODUCT_TYPE_HARDWARE,
        pairNo: pairNo
      })
      , rearProduct, null, null, car);
  }

  getProductsBySpecsAndFilter(accessoryCategoryFilter: AccessoryCategoryFilter,
    filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean)
    : void {
    const p: string = sessionStorage.getItem(`HardwaresPaging`);
    if (p != null) {
      filters.paging.page = JSON.parse(p)["page"];
      filters.paging.pageSize = JSON.parse(p)["pageSize"];
      filters.paging.orderBy = JSON.parse(p)["orderBy"];
    }
    this.searchWithFilterInProgress.next(true);
    let url = decodeURIComponent(window.location.href);
    const showPromotions = url.includes("/promotions");
    var api = "";

    var currentRegion = sessionStorage.getItem("vehicleCountry");
    this.region = currentRegion != null ? currentRegion : "Canada";
    if (showPromotions) {
      api = `${this.apiEndpoint}/${this.region}/accessories/summary?showPromotions=true`;
    }
    else {
      api = `${this.apiEndpoint}/${this.region}/accessories/summary`;
    }
    this.http.post<GenericCardAndFiltersDtoResponse>(api, {
      baseFilter: accessoryCategoryFilter,
      secondaryFilter: filters,
      loadSecondaryFilters: loadSecondaryFilters
    }, { observe: 'response', responseType: 'json' })
      .subscribe(res => {
        let accessoriesAndFiltersDto: GenericCardAndFiltersDtoResponse;

        if (res.status === HTTPStatusCode.NO_CONTENT) {
          accessoriesAndFiltersDto = {
            categoryfilters: null,
            productSummaryCards: [],
            itemCount: 0,
            sortOptions: [],
            hasMoreThanOneOEMTPMS: false,
            boltsNutsInfos: null,
            styleFinish: [],
            micrositeItemCounts: [],
            alternateHexSizeExists: false
          };
        } else {
          accessoriesAndFiltersDto = res.body;
        }
        this.hardwaresSubject.next(accessoriesAndFiltersDto);
        this.searchWithFilterInProgress.next(false);
      },
        Helper.handleError);
  }

  getProductsByVehicleAndFilter(searchParams: MakeYearModel, filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {
    throw new Error('NotSupportedException');
  }

  getProductsByVehicleAndFilterForAccessory(accessoryCategoryFilter: AccessoryCategoryFilter,
    filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {

    var currentRegion = sessionStorage.getItem("vehicleCountry");
    this.region = currentRegion != null ? currentRegion : "Canada";
    const api = `${this.apiEndpoint}/${this.region}/accessories/summary/`;
    this.searchWithFilterInProgress.next(true);

    const p: string = sessionStorage.getItem(`HardwaresPaging`);
    if (p != null) {
      filters.paging.page = JSON.parse(p)["page"];
      filters.paging.pageSize = JSON.parse(p)["pageSize"];
      filters.paging.orderBy = JSON.parse(p)["orderBy"];
    }
    this.http.post<GenericCardAndFiltersDtoResponse>(api, {
      baseFilter: accessoryCategoryFilter,
      secondaryFilter: filters,
      loadSecondaryFilters: loadSecondaryFilters
    }, { observe: 'response', responseType: 'json' })
      .subscribe(cardsAndFilters => {
        let accessoriesAndFiltersDto: GenericCardAndFiltersDtoResponse;
        console.log("TESTING HARDWARE.SERVICE.TS")
        //window.alert("test2")
        //alert("test3")
        if (cardsAndFilters.status === HTTPStatusCode.NO_CONTENT) {
          accessoriesAndFiltersDto = {
            categoryfilters: null,
            productSummaryCards: [],
            itemCount: 0,
            sortOptions: [],
            hasMoreThanOneOEMTPMS: false,
            boltsNutsInfos: null,
            styleFinish: [],
            micrositeItemCounts: [],
            alternateHexSizeExists: false
          };
        } else {
          accessoriesAndFiltersDto = cardsAndFilters.body;
          if (accessoryCategoryFilter && accessoryCategoryFilter.carMake) {
            this.searchMym.make = accessoryCategoryFilter.carMake.values.length > 0 ? accessoryCategoryFilter.carMake.values[0].id : '';
            this.searchMym.year = accessoryCategoryFilter.carYear.values.length > 0 ? accessoryCategoryFilter.carYear.values[0].id : '';
            this.searchMym.model = accessoryCategoryFilter.carModel.values.length > 0 ? accessoryCategoryFilter.carModel.values[0].id : '';
            this.searchMym.submodel = accessoryCategoryFilter.carSubmodel.values.length > 0 ? accessoryCategoryFilter.carSubmodel.values[0].id : '';
          } else {
            this.searchMym.make = '';
            this.searchMym.year = '';
            this.searchMym.model = '';
            this.searchMym.submodel = '';
          }
        }
        this.hardwaresSubject.next(accessoriesAndFiltersDto);
        this.searchWithFilterInProgress.next(false);
      }, Helper.handleError);
  }

  getProductsByVehicleAndFilterForWheel(
    searchParams: MakeYearModel, filters: CategoryFiltersRequestDto,
    loadSecondaryFilters: boolean, frontWheelId: string, rearWheelId: string, frontWheelQty: number, rearWheelQty: number, frontOffset?: number, rearOffset?: number): void {
    this.searchHardwareCardsAndFilters(searchParams, frontWheelId, rearWheelId);
  }
  getProductsByVehicleAndFilterForTire(searchParams: MakeYearModel, filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean, frontTireId: string, rearTireId: string, frontTireQty: number, rearTireQty: number): void {
    throw new Error('NotSupportedException');
  }
  // djb:warn-hidden polymorphism-signature says ProductCategoryFilter, returns AccessoryCategoryFilter
  getCategoryFiltersFromRoute(params: ParamMap): ProductCategoryFilter {
    const makeYearModel = Helper.extractMakeYearModelFromRouteParam(params);
    const categoryFilter = new AccessoryCategoryFilter();

        categoryFilter.categoryId = parseInt(params.get('categoryId'), 10) || 0;
        categoryFilter.productId = params.get('productId');
        if (makeYearModel.isValid) {
            categoryFilter.carYear = new StringCategoryFilter();

            let stringValueId = new StringValueId();
            stringValueId.id = makeYearModel.make;
            stringValueId.value = makeYearModel.make;
            categoryFilter.carMake = new StringCategoryFilter();
            categoryFilter.carMake.values = [stringValueId];

            stringValueId = new StringValueId();
            stringValueId.id = makeYearModel.year;
            stringValueId.value = makeYearModel.year;
            categoryFilter.carYear.values = [stringValueId];

            stringValueId = new StringValueId();
            stringValueId.id = makeYearModel.model;
            stringValueId.value = makeYearModel.model;
            categoryFilter.carModel = new StringCategoryFilter();
            categoryFilter.carModel.values = [stringValueId];

            stringValueId = new StringValueId();
            stringValueId.id = makeYearModel.submodel;
            stringValueId.value = makeYearModel.submodel;
            categoryFilter.carSubmodel = new StringCategoryFilter();
            categoryFilter.carSubmodel.values = [stringValueId];


        }
        return categoryFilter;
    }

  // Used by package builder step hardware.
  searchHardwareCardsAndFilters(params: MakeYearModel, frontWheelId: string, rearWheelId: string): void {
    if (frontWheelId) {

      var currentRegion = sessionStorage.getItem("vehicleCountry");
      this.region = currentRegion != null ? currentRegion : "Canada";
      const rearWheel = rearWheelId && rearWheelId !== '' ? `${rearWheelId}/` : '';
      const api = `${this.apiEndpoint}/${this.region}/accessories/` +
        `makes/${Helper.encodeURIComponent2(params.make)}/` +
        `years/${Helper.encodeURIComponent2(params.getYearStr)}/` +
        `models/${Helper.encodeURIComponent2(params.model)}/` +
        `submodels/${Helper.encodeURIComponent2(params.submodel)}/` +
        `options/${Helper.encodeURIComponent2(params.option)}/` +
        `summer/${Helper.encodeURIComponent2((params.isSummerSeason ? 1 : 0).toString())}/` +
        `wheels/${frontWheelId}/${rearWheel}`; // +
      //`${false}/` +
      //`${false}/`;

      this.http.get<GenericCardAndFiltersDtoResponse>(api).subscribe(cardsAndFilters => {
        this.hardwaresSubject.next(cardsAndFilters);
      }, Helper.handleError);
    }
  }

  clearProducts() {
    this.log(`hs${this.id}.clearProducts`);
    //this.hardwaresSubject = new LastSubject<GenericCardAndFiltersDtoResponse>();
  }

  getMakeYearModel(): MakeYearModel {
    return this.searchMym;
  }

    //djb:diagnostics specific to this service
    private log(msg: string) {
        Helper.log(`HardwareService[${this.id}].${msg}: `);
    }

    postKitToCart(id: string, qty: number): void {
        this.searchComponents(id);

        this.onComponents.subscribe(
            responseProduct => {
                if (responseProduct != null) {
                    const api = `${this.apiCmsEndpoint}/cart/AddKit`;
                    const kitPackage: KitPackage = new KitPackage();

                    kitPackage.kitID = id;
                    kitPackage.kit = this.createProduct(id, qty, Constants.PRODUCT_TYPE_KIT, null, "", 1);
                    kitPackage.package = new StaggeredPackageBuilderModel();
                    kitPackage.package.front = new PackageBuilderModel();
                    kitPackage.package.rear = new PackageBuilderModel();

                    for (let num = 0; num < responseProduct.cards.length; num++) {
                        if (responseProduct.cards[num].id != null) {

                            switch (responseProduct.cards[num].itemCategoryId) {
                                case 1://Accessories
                                    kitPackage.package.front.hardwares.push(this.createProduct(responseProduct.cards[num].id, responseProduct.cards[num].kitQty * qty, Constants.PRODUCT_TYPE_HARDWARE, null, "", num + 2));
                                    break;
                                case 2://Wheels
                                    kitPackage.package.front.wheel = this.createProduct(responseProduct.cards[num].id, responseProduct.cards[num].kitQty * qty, Constants.PRODUCT_TYPE_WHEEL, null, "", num + 2);
                                    break;
                                case 3://Tires
                                    kitPackage.package.front.tire = this.createProduct(responseProduct.cards[num].id, responseProduct.cards[num].kitQty * qty, Constants.PRODUCT_TYPE_TIRE, null, "", num + 2);
                                    break;
                                case 4://Kits
                                case 5://Services
                                case 6://Other
                                    continue;
                                case 7://Consumables
                                    kitPackage.package.front.labours.push(this.createProduct(responseProduct.cards[num].id, responseProduct.cards[num].kitQty * qty, Constants.PRODUCT_TYPE_LABOUR, null, "", num + 2));
                                    break;
                                default:
                                    break;
                            }
                        }
                    }

                    this.http.post(api, kitPackage).toPromise().then(response => {
                        window.location.href = Constants.SHOPPING_CART_HREF;
                    }).catch((err: any) => {
                        window.location.href = Constants.SHOPPING_CART_HREF;
                    });

                }
            }, Helper.handleError);

    }


    searchComponents(searchText: string): void {
        const api = `${this.apiEndpoint}/items/kitcomponents/?id=${encodeURIComponent(searchText)}`;

        this.http.get<KitComponentsDtoResponse>(api).subscribe(componentsDto => {

            this.componentsSubject.next(componentsDto);

        }, Helper.handleError);
    }

    getPlacardToolKits(): Observable<any> {
        throw new Error('NotSupportedException');
    }

    getPlacardToolKitVehicles(kitNo: string): Observable<any> {
        throw new Error('NotSupportedException');
    }

    getPlacardToolPSIs(vehicleOptionID: number, tire: string, rearRire: string): Observable<any> {
        throw new Error('NotSupportedException');
    }

    submitCustomerFeedback(params: ParamMap, comments: string, categoryId: number, departmentResponsible: string, itemNo: string, customerFeedbackOptionId: string): Promise<any> {
        const api = `${this.apiCmsEndpoint}/angular/send/customerfeedback`;
        const makeYearModel = Helper.extractMakeYearModelFromRouteParam(params);
        const data = {
            makeYearModel: makeYearModel,
            comments: comments,
            categoryId: categoryId,
            departmentResponsible: departmentResponsible,
            itemNo: itemNo,
            customerFeedbackOptionId: customerFeedbackOptionId
        };

        return this.http.post(api, data).toPromise();
    }

    getCustomerFeedbackOptions(): Observable<CustomerFeedbackOption[]> {
        const api = `${this.apiCmsEndpoint}/angular/customerfeedbackoption`;

        return this.http.get<CustomerFeedbackOption[]>(api);
    }
}

